module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.portada), function(elitem) {
    return _c('span', [(elitem.acf.template_seccion == 'slideportada') ? _c('span', [_c('slideportada', {
      attrs: {
        "post_id": elitem.id
      }
    })], 1) : _vm._e(), _vm._v(" "), (elitem.acf.template_seccion == 'versiculosdeldia') ? _c('span', [_c('versiculosdeldia')], 1) : _vm._e(), _vm._v(" "), (elitem.acf.template_seccion == 'audios') ? _c('span', [_c('audiosportada', {
      attrs: {
        "post_id": elitem
      }
    })], 1) : _vm._e(), _vm._v(" "), (elitem.acf.template_seccion == 'img_link') ? _c('span', [_c('imglinkportada', {
      attrs: {
        "post_id": elitem
      }
    })], 1) : _vm._e(), _vm._v(" "), (elitem.acf.template_seccion == 'categoria') ? _c('span', [_c('categoriaportada', {
      attrs: {
        "post_id": elitem
      }
    })], 1) : _vm._e(), _vm._v(" "), (elitem.acf.template_seccion == 'versiculos') ? _c('section', {
      staticClass: "col-xs-12"
    }, [_c('versiculosdeldia')], 1) : _vm._e(), _vm._v(" "), (elitem.acf.template_seccion == 'encuesta') ? _c('span', [_c('encuestasportada')], 1) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2430a02b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portada.vue
// module id = 121
// module chunks = 0